<template>
    <div class="test-from-editor">
        <!-- {{testData}} -->
        <h2 class="question__title mb-6" :class="{'question__compact': question.length>200}" v-html="question"></h2>
        <div class="row">
            <div class="col-6">
                <v-btn v-for="answer in column1" :key="answer.id"
                    class="w-100 justify-start answer-button my-3 py-3" @click="onClickAnswer(answer)" :elevation="0" :disabled="loading || disabled"
                    :color="(selectedAnswer && selectedAnswer.id === answer.id) ? 'primary' : ''"
                    :outlined="selectedAnswer && selectedAnswer.id === answer.id" large
                >
                    {{ answer.text }}
                </v-btn>
            </div>
            <div class="col-6">
                <v-btn v-for="answer in column2" :key="answer.id"
                    class="w-100 justify-start answer-button my-3" @click="onClickAnswer(answer)" :elevation="0" :disabled="loading || disabled"
                    :color="(selectedAnswer && selectedAnswer.id === answer.id) ? 'primary' : ''"
                    :outlined="selectedAnswer && selectedAnswer.id === answer.id" large
                >
                    {{ answer.text }}
                </v-btn>
            </div>
        </div>
        <slot name="feedback"/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'TestSimpleQuestion',
    props: {
      disabled: {
        type: Boolean,
        default: () => false,
      }
    },
    computed: {
        ...mapGetters({
            testData: 'testing/testing/testData',
            loading: 'testing/testing/loading',
            selectedAnswer: 'testing/testing/selectedAnswer',
        }),
        question() {
            return `<span>${this.testData.question.text}<span>`;
        },
        column1() {
            const mid = Math.ceil(this.testData.answer_options.length / 2);
            return this.testData.answer_options.slice(0, mid);
        },
        column2() {
            const mid = Math.ceil(this.testData.answer_options.length / 2);
            return this.testData.answer_options.slice(mid);
        },
    },
    methods: {
        ...mapActions({
            sendAnswer: 'testing/testing/sendAnswer',
            setSelectedAnswer: 'testing/testing/setSelectedAnswer',
        }),
        onClickAnswer(answer) {
            this.setSelectedAnswer(answer);
            this.sendAnswer();
        },
    },
};
</script>

<style lang="scss">
</style>
